import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/type.machine.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import AddaPhoto from '@material-ui/icons/AddAPhoto';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import AvatarDialog from '../../../dialogs/Avatar';
import Menu from '../Menu';

import { BlueTickIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleSummit, ok, handleDelete, id) {
    const deleteButton = id ? (
        <TrashIcon
            key="delete-post-machine"
            className="hand"
            color="secondary"
            onClick={handleDelete}
        />
    ) : null;

    const saveButton = ok ? (
        <BlueTickIcon
            disabled={!ok}
            key="submmit-post-machine"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    ) : null;

    return [saveButton, deleteButton];
}

class Machine extends React.Component {
    state = {
        id: randomstring(),
        nombre: '',
        foto: undefined,
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.loadInfo(props.id);
        }
    }

    UNSAFE_componentWillMount() {
        const tools = toolbar(
            this.handleSummit,
            this.isCorrect(),
            this.handleDelete,
            this.props.id,
        );
        this.props.setTools(tools);
    }

    componentDidUpdate() {
        const tools = toolbar(
            this.handleSummit,
            this.isCorrect(),
            this.handleDelete,
            this.props.id,
        );
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.machine && nextProps.id) {
            const { id, nombre, foto } = nextProps.machine;
            this.setState({
                id: id,
                nombre: nombre ? nombre : '',
                foto: foto ? foto : '',
            });
        }
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    openAvatarDialog = (event) => {
        this.setState({ avatarDialog: true });
    };

    closeAvatarDialog = (foto) => {
        console.log(foto);
        if (foto) {
            this.setState({ avatarDialog: false, foto: foto });
        } else {
            this.setState({ avatarDialog: false });
        }
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    isCorrect = () => {
        const { nombre } = this.state;
        return nombre;
    };

    handleDelete = () => {
        const { intl } = this.props;
        const r = window.confirm(intl.formatMessage({ id: 'delete_message_confirm' }));
        if (r === true) {
            this.props
                .deleteMachine(this.props.id)
                .then((r) => {
                    this.props.history.push('/xef/machines');
                })
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        }
    };

    handleSummit = () => {
        const { id, nombre, foto } = this.state;
        const machine = {
            nombre: nombre,
            foto: foto,
        };
        if (!this.props.id) {
            this.props
                .addMachine(machine)
                .then((r) => {
                    this.props.history.push('/xef/machines');
                })
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        } else {
            machine.id = id;
            this.props
                .editMachine(machine)
                .then((r) => {
                    this.props.history.push('/xef/machines');
                })
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        }
    };

    Field = (field, name, intl, autoFocus = false, disable = false) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            margin="normal"
        />
    );

    render() {
        const { nombre, foto, error, avatarDialog } = this.state;
        const { intl, id, machines_is_loading, machines_has_errored, info } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '67')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && machines_has_errored.hasErrored) {
            return (
                <Error open type={machines_has_errored.hasErrored}  message={machines_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    {machines_is_loading && <Loading open opacity />}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row center bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll "
                                onScroll={this.handleScroll}
                            >
                                <div
                                    className="width100 bg_ice_blue shadow"
                                    style={{ height: '85px' }}
                                />
                                <div className="flex_full_row center">
                                    <Avatar className={'avatar-user-menu bg_bluish'}>
                                        {foto && (
                                            <img
                                                src={foto}
                                                alt="Preview"
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                        {!foto && (
                                            <AddaPhoto
                                                className={'c_white'}
                                                style={{ fontSize: 48 }}
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                    </Avatar>
                                </div>
                                <div className="flex_full_column margin_top_18 padding_borders">
                                    {this.Field(nombre, 'nombre', intl, false)}
                                </div>
                            </div>
                        </div>
                        {avatarDialog && (
                            <AvatarDialog open={true} handleClose={this.closeAvatarDialog} />
                        )}
                    </div>
                </div>
            );
        }
    }
}

Machine.propTypes = {
    intl: intlShape.isRequired,
    machine: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    machines_has_errored: PropTypes.object.isRequired,
    machines_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        machines_has_errored: state.type_machines_has_errored,
        machines_is_loading: state.type_machines_is_loading,
        machine: state.type_machine,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(withRouter(Machine)));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/machine/Index.js